import BaseEllipsisText from '@/components/base/BaseEllipsisText';
import { APP_ENV, IS_PROD } from '@/constants';
import useFullscreen from '@/hooks/useFullscreen';
import { useIntl } from '@/i18n';
import { useAuthStore } from '@/store/auth';
import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import { Button, Tag, Tooltip } from 'antd';
import AdminInboxBell from './AdminInboxBell';
import SelectLang from './LanguageSelect';
import UserDropdown from './UserDropdown';

/**
 * 头部右侧操作区
 *
 * 排布按二期原型：环境标签 / 全屏 / 消息 → 机构名 → 语言 → 账户。
 * 暗色模式入口已隐藏（AppProvider 仍支持暗色，需要时把开关加回来即可）。
 *
 * 机构名称直接使用正式会话字段 tenantName，不新增取数或用机构编码替代。
 */
export default function HeaderActions() {
  const [isFullscreen, toggleFullscreen] = useFullscreen();
  const intl = useIntl();
  const orgLabel = useAuthStore((state) => state.tenantName);

  return (
    <div className="admin-header-tools flex flex-[0_0_auto] items-center gap-4 ms-auto">
      {/* 非生产环境显示当前环境，避免把测试包当成线上包 */}
      {!IS_PROD && (
        <Tag
          classNames={{ root: 'admin-header-secondary' }}
          color={APP_ENV === 'staging' ? 'orange' : 'blue'}
          className="me-1"
        >
          {APP_ENV}
        </Tag>
      )}

      <Tooltip
        title={intl.formatMessage({
          id: isFullscreen ? 'layout.exitFullscreen' : 'layout.fullscreen',
        })}
      >
        <Button
          className="admin-header-secondary"
          type="text"
          icon={
            isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />
          }
          onClick={toggleFullscreen}
        />
      </Tooltip>

      <span className="admin-header-secondary">
        <AdminInboxBell />
      </span>

      {orgLabel && (
        <span className="admin-header-organization flex max-w-45 min-[992px]:max-[1101px]:max-w-[130px] pe-4 overflow-hidden border-0 border-e border-solid border-e-split text-text text-[12px] font-semibold leading-[20px] whitespace-nowrap">
          <BaseEllipsisText title={orgLabel} />
        </span>
      )}

      <span className="admin-header-secondary">
        <SelectLang />
      </span>

      <UserDropdown />
    </div>
  );
}
